"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundAndFormatDuration = exports.roundDuration = void 0;
/**
 * Round the duration to the nearest 15 minutes increment
 * @param durationMinutes
 */
const roundDuration = (durationMinutes) => {
    const roundedMinutesTotal = Math.ceil(durationMinutes / 15) * 15;
    const hours = Math.floor(roundedMinutesTotal / 60);
    const minutes = roundedMinutesTotal % 60;
    return { hours, minutes };
};
exports.roundDuration = roundDuration;
/**
 * Round the duration to the nearest 15 minutes increment and format them to `${h} h ${m} m` format.
 * @param durationMinutes
 */
const roundAndFormatDuration = (durationMinutes) => {
    const { hours, minutes } = (0, exports.roundDuration)(durationMinutes);
    if (hours === 0) {
        return `${minutes}m`;
    }
    if (minutes === 0) {
        return `${hours}h`;
    }
    return `${hours}h ${minutes}m`;
};
exports.roundAndFormatDuration = roundAndFormatDuration;
//# sourceMappingURL=roundAndFormatDuration.js.map